import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import {
  selectRequestData,
  selectRequestState
} from "../../../../store/reducers";
import { useEffect, useState } from "react";
import { getSalesforceConfiguration } from "../../../../store/actions/config";
import types from "../../../../store/actionTypes";
import useLoadingState from "../../../../utils/use-loading-state";
import { useString as s } from "../../../../components/StringProvider";
import { message } from "antd";
import SalesforceConnectionForm from "./SalesforceConnectionForm";
import styled from "styled-components";
import loginStateService from "../../../../services/login-state.service";
import Badge from "../../../../components/Discovery/Badge";
import { themeProp } from "../../../../theme";
import Icon from "../../../../components/Icon";
import DisconnectSalesforceModal from "./DisconnectSalesforceModal";

const SalesforceConnection = ({
  salesforceConfiguration,
  loadingState,
  getSalesforceConfiguration
}) => {
  const [editing, setEditing] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const getError = s(
    "generalAdmin.page.salesforceConnection.messages.getError",
    "Failed to fetch connection information"
  );
  const connected = s(
    "generalAdmin.page.salesforceConnection.connected.label",
    "Connected"
  );
  const header = s(
    "generalAdmin.page.salesforceConnection.header",
    "Enter the connection details you generated in Salesforce to activate the connection between Cuvama and Salesforce."
  );

  useEffect(() => {
    getSalesforceConfiguration();
  }, []);

  useEffect(() => {
    setEditing(!salesforceConfiguration);
  }, [salesforceConfiguration]);

  useLoadingState(
    loadingState,
    () => {},
    () => {
      message.error(getError);
    }
  );

  const onSubmit = (values) => {
    const state = loginStateService.saveState(values);
    const url = new URL(`${values.baseUrl}/services/oauth2/authorize`);

    url.searchParams.append("client_id", values.clientId);
    url.searchParams.append("response_type", "code");
    url.searchParams.append(
      "redirect_uri",
      `${window.location.origin}/organizations/general/salesforce-connection-callback`
    );
    url.searchParams.append("state", state);
    window.location.href = url.href;
  };

  const onEdit = () => {
    setEditing(true);
  };

  const onCancelEdit = () => {
    setEditing(false);
  };

  const onDisconnect = () => {
    setDeleteModalVisible(true);
  };

  return (
    <Container>
      <TitleBar>
        {header}
        {salesforceConfiguration && salesforceConfiguration.connected ? (
          <Badge
            color={"surface"}
            bg={themeProp(`palette.success`)}
            variant={"small"}
            data-cy={`connected-badge`}
          >
            <Block>
              <Icon name={"check"} size={11} />
            </Block>
            <Block>{connected}</Block>
          </Badge>
        ) : null}
      </TitleBar>
      <SalesforceConnectionForm
        salesforceConfiguration={salesforceConfiguration}
        onFinish={onSubmit}
        onCancel={onCancelEdit}
        onDisconnect={onDisconnect}
        onEdit={onEdit}
        readOnly={!editing}
      />
      {deleteModalVisible ? (
        <DisconnectSalesforceModal
          onClose={() => setDeleteModalVisible(false)}
        />
      ) : null}
    </Container>
  );
};

const Block = styled.div`
  vertical-align: middle;
  display: inline-block;
  margin-right: 5px;
`;

const TitleBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: baseline;
  min-height: 32px;
  margin-bottom: 25px;
`;

const Container = styled.div`
  max-width: 550px;
`;

const mapStateToProps = (state) => ({
  loadingState: selectRequestState(
    state,
    types.GET_SALESFORCE_CONFIGURATION_REQUEST
  ),
  salesforceConfiguration: selectRequestData(
    state,
    types.GET_SALESFORCE_CONFIGURATION_REQUEST
  )
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSalesforceConfiguration
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SalesforceConnection
);
